import { render } from "./detail.vue?vue&type=template&id=676a4cae"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=676a4cae&lang=scss"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/widget/shop/tiktok/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "676a4cae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('676a4cae', __exports__)) {
    console.log('reload')
    api.reload('676a4cae', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=676a4cae", () => {
    console.log('re-render')
    api.rerender('676a4cae', render)
  })

}


export default __exports__